var _ = require('underscore');
var config = require('js/config');
var Collection = require('js/lib/collection');
var Community = require('js/models/community');
var parseESResponse = require('js/lib/parseESResponse');

/**
 * Communities
 * @exports Communities
 * @constructor
 * @alias module:collections/community
 */
var Communities = Collection.extend({
  model: Community,
  options: {
    // Default resource description
    description: {
      pageNumber: 1,
      showPrivate: true,
    },
  },
  url: config.build.apiPath + '/api/communities',
  recommendedUrl: config.build.apiPath + '/api/communities/recommended',
  searchUrl: config.build.apiPath + '/api/communities/search',

  // Data cache
  dataCacheMap: {
    'groups': Collection.extend({model: Community}),
  },
});

/**
 * Parse response payload from api
 */
Communities.prototype.parse = function(resp) {
  if (resp.hits && resp.groups) {
    // Ensure data cache
    this.ensureDataCache(resp, this.dataCacheMap, {accumulate: true});
  }

  resp = resp.hits ? parseESResponse(resp) : resp;

  var groups = resp.groups || resp.communities || [];

  this.total = resp.total;

  return this.description.showPrivate !== false ? groups :
    _.filter(groups, function(group) {
      return !group.isPrivate;
    });
};

/**
 * Get recommended communities (curated)
 */
Communities.prototype.fetchRecommended = function(groupCode) {
  this.desc('subDomain', groupCode);
  return this.fetch({
    url: this.recommendedUrl,
  });
};

/**
 * Search communities
 */
Communities.prototype.search = function(key, options) {
  this.desc('showPrivate', config.search.showPrivateCommunities);

  options = options || {};
  options.url = this.searchUrl;
  options.data = {
    key: key,
    pageNumber: this.description.pageNumber || 1,
    pageSize: config.pageSize.relatedCommunities,
  };

  return this.fetch(options);
};

/**
 * Search communities
 */
Communities.prototype.fetchCommunitySearch = function(key, options) {
  return this.desc('key', key).desc('es', true).fetch(_.extend({
    url: config.build.apiPath + '/api/communities/search',
  }, options));
};

/**
 * Use search to fetch single community into the collection via groupCode
 */
Communities.prototype.fetchCommunityFromSearch = function(groupCode, options) {
  return this.desc('groupCode', groupCode).fetch(_.extend({
    url: config.build.apiPath + '/api/communities/search/get',
  }, options));
};

Communities.prototype.debouncedSearch = _.debounce(Communities.prototype.search, config.api.burst.wait);

module.exports = Communities;



// WEBPACK FOOTER //
// ./app/assets/js/collections/communities.js